// export const MAP_API_KEY = 'AIzaSyB-HP8-vzKPsK5LR8zERPCHVnS2DMFi8wc';
export const MAP_API_KEY =
  'AIzaSyAjIxvt55l1UUjF3mIBC4MSGIhhSHSG8nY'; /* current site api key */
